export class PeriodType {
    static get period(): string { return "PERIOD"; }
    static get month(): string { return "MANAD"; }
    static get week(): string { return "VECKA"; }
    static get day(): string { return "DAG"; }
    static get periodTypes(): string[] {
        return [
            PeriodType.period,
            PeriodType.month,
            PeriodType.week,
            PeriodType.day
        ];
    }
}
